module.exports = __webpack_public_path__ + "static/media/custom2.7fbc66ac.png";